import React, { useEffect, useState } from 'react';
import { useGlobalData } from '../context/GlobalDataContext';

const FAQPage = () => {
  const { faqs, loading: globalLoading, fetchFaqs } = useGlobalData();
  const [openIndex, setOpenIndex] = useState(null);
  const [darkMode, setDarkMode] = useState(document.body.classList.contains('dark-mode'));

  // FAQ page open hote hi FAQ data fetch
  useEffect(() => {
    fetchFaqs();
  }, [fetchFaqs]);

  // Sync dark mode with Navbar
  useEffect(() => {
    const handler = () => setDarkMode(document.body.classList.contains('dark-mode'));
    window.addEventListener('darkModeChanged', handler);
    return () => window.removeEventListener('darkModeChanged', handler);
  }, []);

  return (
    <div style={{
      maxWidth: 700,
      margin: '40px auto',
      padding: 24,
      // background: darkMode ? '#181a2a' : '#fff',
      borderRadius: 8,
      // boxShadow: darkMode ? '0 2px 8px rgba(0,0,0,0.32)' : '0 2px 8px rgba(0,0,0,0.08)',
      color: darkMode ? '#f1f5f9' : '#222',
      transition: 'background 0.2s, color 0.2s'
    }}>
      <h2>Frequently Asked Questions (FAQ)</h2>
      {globalLoading ? <p>Loading...</p> : (
        <div>
          {faqs && faqs.length === 0 ? <p>No FAQs found.</p> : (
            <ul style={{listStyle:'none',padding:0}}>
              {faqs.map((faq, idx) => (
                <li key={faq._id} style={{marginBottom:16, padding:0, background: darkMode ? '#23263a' : '#f6f8fa', borderRadius:6, overflow:'hidden'}}>
                  <button
                    onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                    style={{
                      width: '100%',
                      textAlign: 'left',
                      background: 'none',
                      border: 'none',
                      padding: '16px',
                      fontSize: '1.1rem',
                      fontWeight: 600,
                      cursor: 'pointer',
                      outline: 'none',
                      borderBottom: openIndex === idx ? '1px solid #007bff' : '1px solid #e5e7eb',
                      color: darkMode ? '#f1f5f9' : '#222'
                    }}
                  >
                    Q: {faq.question}
                  </button>
                  {openIndex === idx && (
                    <div style={{padding:'16px', background: darkMode ? '#23263a' : '#e9ecef', color: darkMode ? '#f1f5f9' : '#333', fontSize:'1rem', whiteSpace: 'pre-line'}}>
                      <strong>A:</strong> {faq.answer}
                    </div>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

export default FAQPage;
